import React, { useState } from "react";
import { useToast } from "../../hooks/use-toast";
import { adminLogin } from "../../lib/api";
import Logo from "../../components/Logo";

export default function LoginScreen({ onLogin }) {
  const { toast } = useToast();
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    if (!password) {
      toast({ title: "Please enter the admin password." });
      return;
    }
    setSubmitting(true);
    try {
      await adminLogin(password);
      onLogin();
    } catch (err) {
      toast({ title: "Invalid password" });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="nn-page-bg min-h-screen flex items-center justify-center p-6">
      <div className="bg-white shadow-xl w-full max-w-md p-8 border border-[#d6dcb6]">
        <div className="mb-6">
          <Logo className="max-w-[280px] mx-auto" />
        </div>
        <h1 className="font-display text-2xl text-[#7d8e54] text-center mb-2">Admin Dashboard</h1>
        <p className="text-sm text-center text-[#7d8e54] mb-6">
          Enter the admin password to continue.
        </p>
        <form onSubmit={onSubmit} className="space-y-3">
          <input
            type="password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Admin password"
            className="w-full border border-[#d6dcb6] px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8da55f]"
          />
          <button
            type="submit"
            disabled={submitting}
            className="nn-sage-dark w-full py-2 font-display tracking-wider hover:bg-[#5b6a37] disabled:opacity-60 transition-colors"
          >
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
